<template>
  <div id="wrapper">

    <header v-if="isLogin">
      <div class="container">
        <div class="w-full justify-between items-center md:flex">
          <div class="head_L flex items-center">
            <!-- <a class="logo" href="../">
              <img src="../images/logo.png" alt="">
            </a> -->
            <router-link v-if="store.loginInfo.corporationName == '啟耀'" class="logo" to="/store/index">
              <img src="../images/logo.png" alt="">
            </router-link>
            <router-link v-else-if="store.loginInfo?.isEmp" class="logo" to="/">
              <img src="../images/logo.png" alt="">
            </router-link>
            <router-link v-else class="logo" to="/activity/index">
              <img src="../images/logo.png" alt="">
            </router-link>
          </div>

          <div class="head_R">
            <nav>
              <!-- 法人: 啟耀 -->
              <ul v-if="store.loginInfo.corporationName == '啟耀'" class="menuList">
                <li v-if="store.loginInfo?.isQRHelper != true">
                  <router-link v-slot="{ href }" to="/store" custom>
                    <a :href="href" class="menuSub" :class="{ 'active': $route.path.startsWith('/store') }"
                      @click.prevent>
                      特約商店
                    </a>
                  </router-link>
                  <ul class="subList">
                    <li><router-link to="/store/index">瀏覽特約商店</router-link></li>
                    <li><router-link to="/store/choice">嚴選網站</router-link></li>
                  </ul>
                </li>
                <!--  -->

                <li class="mShow user-function"> <a @click="logout">登出</a></li>
              </ul>

              <!-- 員工選單 -->
              <ul v-else-if="store.loginInfo?.isEmp" class="menuList">
                <li><router-link to="/">首頁</router-link></li>
                <li v-if="store.loginInfo?.isQRHelper != true">
                  <router-link v-slot="{ href }" to="/info" custom>
                    <a :href="href" class="menuSub" :class="{ 'active': $route.path.startsWith('/info') }"
                      @click.prevent>
                      職福資訊
                    </a>
                  </router-link>
                  <ul class="subList">
                    <li><router-link to="/info/news">公告訊息</router-link></li>
                    <li><router-link to="/info/members">職福會資訊</router-link></li>
                    <li><router-link to="/info/minutes">會議紀錄</router-link></li>
                  </ul>
                </li>
                <li v-if="store.loginInfo?.isQRHelper != true">
                  <router-link v-slot="{ href }" to="/activity" custom>
                    <a :href="href" class="menuSub" :class="{ 'active': $route.path.startsWith('/activity') }"
                      @click.prevent>
                      活動報名
                    </a>
                  </router-link>
                  <ul class="subList">
                    <li><router-link to="/activity/index">近期活動</router-link></li>
                    <li><router-link to="/activity/registered">已報名活動</router-link></li>
                  </ul>
                </li>
                <li v-if="store.loginInfo?.isQRHelper != true">
                  <router-link v-slot="{ href }" to="/club" custom>
                    <a :href="href" class="menuSub" :class="{ 'active': $route.path.startsWith('/club') }"
                      @click.prevent>
                      社團活動
                    </a>
                  </router-link>
                  <ul class="subList">
                    <li><router-link to="/club/index">社團活動</router-link></li>
                    <!-- <li><router-link to="/club/myclub">我的社團</router-link></li> -->
                  </ul>
                </li>
                <li v-if="store.loginInfo?.isQRHelper != true">
                  <router-link v-slot="{ href }" to="/store" custom>
                    <a :href="href" class="menuSub" :class="{ 'active': $route.path.startsWith('/store') }"
                      @click.prevent>
                      特約商店
                    </a>
                  </router-link>
                  <ul class="subList">
                    <li><router-link to="/store/index">瀏覽特約商店</router-link></li>
                    <li><router-link to="/store/promot">我要推薦</router-link></li>
                    <li><router-link to="/store/promotRecord">推薦紀錄</router-link></li>
                    <li><router-link to="/store/choice">嚴選網站</router-link></li>
                  </ul>
                </li>
                <li v-if="store.loginInfo?.isQRHelper != true">
                  <router-link v-slot="{ href }" to="/allowance" custom>
                    <a :href="href" class="menuSub" :class="{ 'active': $route.path.startsWith('/allowance') }"
                      @click.prevent>
                      福利津貼
                    </a>
                  </router-link>
                  <ul class="subList">
                    <li><router-link to="/allowance/index">申請津貼</router-link></li>
                    <li><router-link to="/allowance/record">申請紀錄</router-link></li>
                  </ul>
                </li>
                <li v-if="store.loginInfo?.isQRHelper != true">
                  <router-link v-slot="{ href }" to="/service" custom>
                    <a :href="href" class="menuSub" :class="{ 'active': $route.path.startsWith('/service') }"
                      @click.prevent>
                      按摩小站
                    </a>
                  </router-link>
                  <ul class="subList">
                    <li><router-link to="/service/reserve">預約按摩</router-link></li>
                    <li><router-link to="/service/record">按摩紀錄</router-link></li>
                  </ul>
                </li>
                <li><router-link to="/questionnaire">問卷調查</router-link></li>
                <!--  -->
                <li class="mShow user-function"> <a @click="logout">登出</a></li>
              </ul>

              <!-- 會員選單 -->
              <ul v-else-if="!store.loginInfo.isEmp" class="menuList">
                <li v-if="store.loginInfo?.isQRHelper != true">
                  <router-link v-slot="{ href }" to="/activity" custom>
                    <a :href="href" class="menuSub" :class="{ 'active': $route.path.startsWith('/activity') }"
                      @click.prevent>
                      活動報名
                    </a>
                  </router-link>
                  <ul class="subList">
                    <li><router-link to="/activity/index">近期活動</router-link></li>
                    <li><router-link to="/activity/registered">已報名活動</router-link></li>
                  </ul>
                </li>
                <!--  -->
                <li class="mShow user-function">
                  <a @click="router.push('/employee/maintain')">個人資料維護</a>
                </li>
                <li class="mShow user-function">
                  <a @click="router.push('/employee/modifyPassword')">修改密碼</a>
                </li>
                <li class="mShow user-function"> <a @click="logout">登出</a></li>
              </ul>

              <div class="memberMenu">
                <ul class="menuList">
                  <li>
                    <a class="memberBtn">
                      <div class="memberPic"><img src="../images/ic_man.svg" alt=""></div>
                      <div class="memberName">{{ model.empName }}</div>
                    </a>
                    <ul class="pcShow subList ">
                      <li v-if="!store.loginInfo.isEmp"> <a @click="router.push('/employee/maintain')">個人資料維護</a></li>
                      <li v-if="!store.loginInfo.isEmp"> <a @click="router.push('/employee/modifyPassword')">修改密碼</a>
                      </li>
                      <li> <a @click="logout">登出</a></li>
                    </ul>
                  </li>
                </ul>
              </div>

            </nav>
          </div>
        </div>
        <div ref="menuBtn" class="menuBtn">
          <div></div>
        </div>
      </div>
    </header>
    <!-- main-->
    <slot></slot>
    <!-- footer-->
    <footer>
      <div class="companyInfo">
        <div class="container">
          <div class="block md:flex">
            <h2 class="text-24 font-bold md:text-34">職福會系統</h2>
            <div v-if="store && store.layout" class="cpyinfoBox flex text-14 md:text-18">
              <div class="cpyinfoTent">
                <div class="cpyInfo"><b>聯絡信箱</b>
                  <div>{{ store.layout.footerEMail }} </div>
                </div>
                <div class="cpyInfo"><b>傳真電話</b>
                  <div>{{ store.layout.footerFAX }}</div>
                </div>
                <div class="cpyInfo"><b>聯絡電話</b>
                  <div>{{ store.layout.footerPhone }}</div>
                </div>
              </div>
              <div class="cpyinfoTent">
                <div v-for="v in store.layout.corporationList" :key="v" class="cpyInfo">
                  <b>{{ v.officeNAME }}</b>
                  <div>{{ v.officeUBN }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightsBox">
        <div class="container">
          <div class="flex justify-between items-center">
            <div class="rightsB_L"><a class="inline-block" href="#">隱私權條款</a><span
                class="inline-block mx-2 md:mx-4">|</span><a class="inline-block" href="#">著作權聲明</a></div>
            <div class="rightsB_R">
              群創光電版權所有</div>
          </div>
        </div>
      </div>
    </footer>
    <div class="goTopBtn"> <img src="../images/goTop.png" alt=""></div>

  </div>
  <Enum ref="enumRef" />
</template>

<script setup>
import { ref, provide, inject, onMounted, reactive, watch, nextTick, onBeforeMount } from "vue";
import { useRouter, useRoute } from 'vue-router';
import api from '@/api/base'
import Enum from '@/components/Enum.vue'

const router = useRouter();
const route = useRoute();

onBeforeMount(async () => {
  const token = localStorage.getItem('AuthorizationToken');
  if (!token) { router.push('/login') }
})

const storer = inject('store');
const store = ref(null)

watch(() => storer.value, (nv) => {
  if (nv) {
    store.value = nv.get();
  }
}, { immediate: true })

const enumRef = ref(null);
provide('enums', enumRef)

const isLogin = ref(false);

const logout = async () => {
  let loginInfo = storer.value.model.loginInfo;

  switch (loginInfo.Identity) {
    default:
    case '1':
      await api.formPost(`/Login/EmpLogout`, { empNo: loginInfo.account })
      break;
    case '2':
      await api.formPost(`/Login/MemberLogout`, { acnt: loginInfo.account })
      break;
  }
  localStorage.removeItem('LoginInfo');
  localStorage.removeItem('AuthorizationToken');
  localStorage.removeItem('AgreePrivacy')
  storer.value.model.loginInfo = null;
  router.push('/login')
}

const menuBtn = ref(null);
const model = reactive({});

onMounted(async () => {

  let storeM = storer.value.model;
  store.value = storeM;
  watch(() => storeM.loginInfo, (nv, ov) => {
    if (nv != null) {
      Object.assign(model, nv);
      isLogin.value = true;

      nextTick(() => {
        headerInit();
      })
    }
    else {
      isLogin.value = false;
    }
  });

  let info = localStorage.getItem('LoginInfo')
  if (!info) { router.push('/login') }
  store.value.loginInfo = JSON.parse(info);

  const layout = ref(null);
  api.get('/Home/GetBannerFooter').then(async (res) => {
    if (res.data.success) {
      layout.value = res.data.data;
      layout.value.bannerBase64 = []

      let base64List = [];
      for (let i = 0; i < layout.value.bannerImage.length; i++) {
        let v = layout.value.bannerImage[i];
        await storer.value.getbase64(v).then((ba) => {
          base64List.push(ba);
        })
      }
      layout.value.bannerBase64 = base64List;
      store.value.layout = layout
    }
  })
})

const headerInit = () => {
  // 選單開合
  let isTouchDevice = false
  let isDeviceDetected = false
  if (document.querySelector('.menuBtn')) {
    document.querySelectorAll('.menuList > li').forEach((e, i) => {
      // PC
      e.addEventListener('mouseenter', (event) => {
        if (!isDeviceDetected) {
          isTouchDevice = false;
          isDeviceDetected = true;
        }
        if (isTouchDevice) return;
        if (!e.classList.contains('menuOpen')) {
          e.classList.add('menuOpen')
        }
      })
      e.addEventListener('mouseleave', (event) => {
        if (isTouchDevice) return;
        if (e.classList.contains('menuOpen')) {
          e.classList.remove('menuOpen')
        }
      })

      // mobile
      e.addEventListener('touchstart', (event) => {
        if (!isDeviceDetected) {
          isTouchDevice = true;
          isDeviceDetected = true;
        }

        if (!e.classList.contains('menuOpen')) {
          e.classList.add('menuOpen')
        } else {
          e.classList.remove('menuOpen')
        }

        if (!event.target.classList.contains('menuSub')) {
          event.target.click()
          menuBtn.value.click()
        }
      })
    })

    const header = document.querySelector('header')
    document.querySelector('.menuBtn').addEventListener('click', () => {
      if (!header.classList.contains('navOpen')) {
        header.classList.add('navOpen')
      } else {
        header.classList.remove('navOpen')
      }
    })
  }

  // GoTop
  document.querySelector('.goTopBtn').addEventListener('click', () => {
    window.scrollTo({ behavior: 'smooth', 'top': 0 })
  })

}

const logoutTmp = async (account) => {
  await api.post(`/Login/LogoutTmp/${account}`)
}

</script>

<style scoped>
.menuList .subList a {
  cursor: pointer;
}

.privacy-policy {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 8em;
  padding: 1em 2em;
  z-index: 100;
}

.privacy-container {
  width: 100%;
  padding: 1em;
  height: 100%;
  background-color: #eeeeeed9;
  border-radius: 0.5em;
  box-shadow: 0px 2px 4px 0px #aaa;
}

.privacy-text {
  flex-grow: 1;
}

.privacy-button-box {
  flex-basis: 30%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0em 1em;
}

.privacy-button-box button {
  border: 1px solid #0095ff;
  padding: 0.5em 1em;
  border-radius: 0.5em;
  color: blue;
  font-weight: bold;
  transition: 0.2s;
}

.privacy-button-box button:hover {
  background-color: blue;
  color: white;
}

.privacy-view {
  color: rgb(31, 116, 244);
  font-weight: bold;
  cursor: pointer;
}
</style>
